import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  formData: {
    // e.g. name: '', photoId: '', etc.
  },
  currentStep: localStorage.getItem("currentStep") || 1,
  showPopup: false,
};

const formSlice = createSlice({
  name: "form",
  initialState,
  reducers: {
    updateFormData: (state, action) => {
      const { field, value } = action.payload;
      state.formData[field] = value;
    },
    setFormData: (state, action) => {
      state.formData = action.payload;
    },
    resetFormData: (state) => {
      state.formData = {};
    },
    setCurrentStepRedux: (state, action) => {
      // localStorage.setItem("currentStep", action.payload);
      state.currentStep = action.payload;
    },
    clearCurrentStep: (state) => {
      localStorage.removeItem("currentStep");
      state.currentStep = 1;
    },
    setShowPopupRedux: (state, action) => {
      // localStorage.setItem("currentStep", action.payload);
      state.showPopup = action.payload;
    },
    clearShowPopupStep: (state) => {
      localStorage.removeItem("currentStep");
      state.showPopup = false;
    },
  },
});

export const {
  updateFormData,
  setFormData,
  resetFormData,
  setCurrentStepRedux,
  clearCurrentStep,
  setShowPopupRedux,
  clearShowPopupStep,
} = formSlice.actions;
export default formSlice.reducer;

//  const formData = useSelector((state) => state.form.formData);

//   const handleChange = (e) => {
//     dispatch(updateFormData({ field: 'name', value: e.target.value }));
//   };
// dispatch(resetFormData());
